function isProductGalleryFixedRatio(mediaWrapper) {
  if (!mediaWrapper) return false;

  const desktop =
    mediaWrapper.getAttribute("data-gallery-ratio-desktop") || "adapt";
  const mobile =
    mediaWrapper.getAttribute("data-gallery-ratio-mobile") || "adapt";
  const isMobile = window.matchMedia("(max-width: 989px)").matches;
  const activeRatio = isMobile ? mobile : desktop;

  return activeRatio !== "adapt";
}

let productMediaRatioResizeTimer;
if (typeof window !== "undefined") {
  window.addEventListener("resize", () => {
    clearTimeout(productMediaRatioResizeTimer);
    productMediaRatioResizeTimer = setTimeout(() => {
      document
        .querySelectorAll(".product__media-wrapper")
        .forEach((mediaWrapper) => {
          if (!isProductGalleryFixedRatio(mediaWrapper)) return;

          const sectionRoot = mediaWrapper.closest(
            ".product-section, .featured-product-section"
          );
          refreshProductMediaSlickPositionsAfterRender(
            sectionRoot || mediaWrapper
          );
        });
    }, 200);
  });
}

function getSliderSettings(subSlider, mediaWrapper) {
  const fixedRatio = isProductGalleryFixedRatio(mediaWrapper);

  return {
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    infinite: false,
    adaptiveHeight: false,
    asNavFor: subSlider ? subSlider[0] : ".product__media-sublist",
    prevArrow:
      '<div class=\'slick-arrow  slick-prev\'> <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M1.75247 7.76459L1.04536 8.47169L1.75247 9.1788L7.83781 15.2641L8.54492 14.557L2.45958 8.47169L8.54492 2.38635L7.83782 1.67924L1.75247 7.76459Z" fill="#5C5C5C"/>' +
      '<path d="M1.04536 8.47169L0.69181 8.11814L0.338257 8.47169L0.691809 8.82525L1.04536 8.47169ZM1.75247 7.76459L2.10602 8.11814L2.10602 8.11814L1.75247 7.76459ZM1.75247 9.1788L1.39891 9.53235L1.39892 9.53235L1.75247 9.1788ZM7.83781 15.2641L7.48426 15.6177L7.83781 15.9713L8.19137 15.6177L7.83781 15.2641ZM8.54492 14.557L8.89847 14.9106L9.25203 14.557L8.89847 14.2035L8.54492 14.557ZM2.45958 8.47169L2.10602 8.11814L1.75247 8.47169L2.10602 8.82525L2.45958 8.47169ZM8.54492 2.38635L8.89848 2.7399L9.25203 2.38635L8.89848 2.0328L8.54492 2.38635ZM7.83782 1.67924L8.19137 1.32569L7.83782 0.972136L7.48426 1.32569L7.83782 1.67924ZM1.39892 8.82525L2.10602 8.11814L1.39892 7.41103L0.69181 8.11814L1.39892 8.82525ZM2.10602 8.82525L1.39892 8.11814L0.691809 8.82525L1.39891 9.53235L2.10602 8.82525ZM8.19137 14.9106L2.10602 8.82525L1.39892 9.53235L7.48426 15.6177L8.19137 14.9106ZM8.19137 14.2035L7.48426 14.9106L8.19137 15.6177L8.89847 14.9106L8.19137 14.2035ZM2.10602 8.82525L8.19137 14.9106L8.89847 14.2035L2.81313 8.11814L2.10602 8.82525ZM8.19137 2.0328L2.10602 8.11814L2.81313 8.82525L8.89848 2.7399L8.19137 2.0328ZM7.48426 2.0328L8.19137 2.7399L8.89848 2.0328L8.19137 1.32569L7.48426 2.0328ZM2.10602 8.11814L8.19137 2.0328L7.48426 1.32569L1.39892 7.41103L2.10602 8.11814Z" fill="#5C5C5C"/>' +
      "</svg> </div>",
    nextArrow:
      '<div class=\'slick-arrow  slick-next\'> <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M8.24753 8.23541L8.95464 7.5283L8.24753 6.8212L2.16218 0.735851L1.45508 1.44296L7.54042 7.5283L1.45508 13.6136L2.16218 14.3208L8.24753 8.23541Z" fill="#5C5C5C"/>' +
      '<path d="M8.95464 7.5283L9.30819 7.88186L9.66174 7.5283L9.30819 7.17475L8.95464 7.5283ZM8.24753 8.23541L7.89398 7.88186V7.88186L8.24753 8.23541ZM8.24753 6.8212L8.60108 6.46764H8.60108L8.24753 6.8212ZM2.16218 0.735851L2.51574 0.382298L2.16218 0.0287447L1.80863 0.382298L2.16218 0.735851ZM1.45508 1.44296L1.10152 1.0894L0.747971 1.44296L1.10152 1.79651L1.45508 1.44296ZM7.54042 7.5283L7.89398 7.88186L8.24753 7.5283L7.89398 7.17475L7.54042 7.5283ZM1.45508 13.6136L1.10152 13.2601L0.747971 13.6136L1.10152 13.9672L1.45508 13.6136ZM2.16218 14.3208L1.80863 14.6743L2.16218 15.0279L2.51574 14.6743L2.16218 14.3208ZM8.60108 7.17475L7.89398 7.88186L8.60108 8.58896L9.30819 7.88186L8.60108 7.17475ZM7.89398 7.17475L8.60108 7.88186L9.30819 7.17475L8.60108 6.46764L7.89398 7.17475ZM1.80863 1.08941L7.89398 7.17475L8.60108 6.46764L2.51574 0.382298L1.80863 1.08941ZM1.80863 1.79651L2.51574 1.08941L1.80863 0.382298L1.10152 1.0894L1.80863 1.79651ZM7.89398 7.17475L1.80863 1.0894L1.10152 1.79651L7.18687 7.88186L7.89398 7.17475ZM1.80863 13.9672L7.89398 7.88186L7.18687 7.17475L1.10152 13.2601L1.80863 13.9672ZM2.51574 13.9672L1.80863 13.2601L1.10152 13.9672L1.80863 14.6743L2.51574 13.9672ZM7.89398 7.88186L1.80863 13.9672L2.51574 14.6743L8.60108 8.58896L7.89398 7.88186Z" fill="#5C5C5C"/>' +
      "</svg></div>",
    responsive: fixedRatio
      ? []
      : [
          {
            breakpoint: 990,
            settings: {
              adaptiveHeight: true,
            },
          },
        ],
  };
}

function getSubSliderProductSettings(slider) {
  return {
    slidesToScroll: 1,
    arrows: false,
    asNavFor: slider ? slider[0] : ".product__media-list",
    focusOnSelect: true,
    verticalSwiping: false,
    autoplay: false,
    infinite: false,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 3000,
        settings: {
          slidesToShow: 7,
          vertical: true,
          useTransform: false,
          variableWidth: false,
        },
      },
      {
        breakpoint: 990,
        settings: {
          vertical: false,
          variableWidth: true,
          useTransform: true,
          centerMode: true,
          centerPadding: "0px",
        },
      },
    ],
  };
}

var syncProductMediaSublistHeightsTimer;

function syncProductMediaSublistHeights() {
  if (!window.matchMedia("(min-width: 990px)").matches) {
    $(".product__media-sublist .slick-list").css("max-height", "");
    return;
  }

  $(".product__media-list-wrapper").each(function () {
    var $wrap = $(this);
    var $main = $wrap.children(".product__media-list").first();
    var $sub = $wrap.children(".product__media-sublist").first();
    if (!$main.length || !$sub.length) return;
    if (
      !$main.hasClass("slick-initialized") ||
      !$sub.hasClass("slick-initialized")
    )
      return;

    var $mainList = $main.find(".slick-list").first();
    var $subList = $sub.find(".slick-list").first();
    var h = $mainList.outerHeight();
    if (h > 0) {
      $subList.css("max-height", h + "px");
    }
  });
}

function syncProductMediaSublistHeightsDebounced() {
  clearTimeout(syncProductMediaSublistHeightsTimer);
  syncProductMediaSublistHeightsTimer = setTimeout(
    syncProductMediaSublistHeights,
    150
  );
}

function refreshProductMediaSlickPositions(root) {
  if (!window.jQuery) return;
  var $root = root ? (root instanceof jQuery ? root : $(root)) : $(document);
  $root.find(".product__media-list.slick-initialized").each(function () {
    try {
      $(this).slick("setPosition");
    } catch (e) {}
  });
  $root.find(".product__media-sublist.slick-initialized").each(function () {
    try {
      $(this).slick("setPosition");
    } catch (e) {}
  });
}

function refreshProductMediaSlickPositionsAfterRender(root) {
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      refreshProductMediaSlickPositions(root);
      syncProductMediaSublistHeights();
    });
  });
}

function bindProductMediaImageLoadRefresh(root) {
  if (!window.jQuery) return;
  var $root = root ? (root instanceof jQuery ? root : $(root)) : $(document);
  $root.find(".product__media-list-wrapper").each(function () {
    var wrapper = this;
    $(wrapper)
      .find(".product__media-list img, .product__media-sublist img")
      .each(function () {
        var img = this;
        if (img.dataset.productMediaLoadBound === "true") {
          if (img.complete) {
            refreshProductMediaSlickPositionsAfterRender(wrapper);
          }
          return;
        }

        img.dataset.productMediaLoadBound = "true";

        var refresh = function () {
          refreshProductMediaSlickPositionsAfterRender(wrapper);
        };

        if (img.complete) {
          refresh();
        } else {
          img.addEventListener("load", refresh, { once: true });
          img.addEventListener("error", refresh, { once: true });
        }
      });
  });
}

window.syncProductMediaSublistHeights = syncProductMediaSublistHeights;

/**
 * Tear down Slick on product gallery nodes before replacing innerHTML (combined listings / section fetch).
 * Destroy thumbnails first because of asNavFor.
 */
function destroyProductMediaSliders(root) {
  if (!root || !window.jQuery) return;
  var $root = root instanceof jQuery ? root : $(root);
  $root.find(".product__media-sublist.slick-initialized").each(function () {
    try {
      $(this).slick("unslick");
    } catch (e) {}
  });
  $root.find(".product__media-list.slick-initialized").each(function () {
    try {
      $(this).slick("unslick");
    } catch (e) {}
  });
  $root.find(".product__media-list").off("afterChange.productMediaPause");
}

/**
 * Initialize main + thumbnail sliders inside a product section (after DOM swap).
 */
function initProductMediaSliders(root) {
  // ELD-151: an app can load its own jQuery after the theme's and replace
  // window.jQuery with a copy that has no slick. Skip instead of throwing, or the
  // variant change stops before it updates the price.
  if (!root || !window.jQuery || typeof window.jQuery.fn.slick !== "function")
    return;
  // Use the copy just checked. An app's jQuery.noConflict() can leave $ on
  // another copy, one without slick.
  var $ = window.jQuery;
  var $root = root instanceof $ ? root : $(root);
  $root.find(".product__media-list").each(function () {
    var $list = $(this);
    if (!$list.children().length) return;
    if ($list.hasClass("slick-initialized")) return;
    var $sub = $list.parent().find(".product__media-sublist").first();
    var mediaWrapper = $list.closest(".product__media-wrapper")[0];
    $list.slick(getSliderSettings($sub, mediaWrapper));
  });
  $root.find(".product__media-sublist").each(function () {
    var $sub = $(this);
    if (!$sub.children().length) return;
    if ($sub.hasClass("slick-initialized")) return;
    var $main = $sub.parent().find(".product__media-list").first();
    $sub.slick(getSubSliderProductSettings($main));
  });
  $root
    .find(".product__media-list")
    .off("afterChange.productMediaPause")
    .on("afterChange.productMediaPause", function () {
      window.pauseAllMedia();
    });
  bindProductMediaImageLoadRefresh($root);
  refreshProductMediaSlickPositionsAfterRender($root);
}

/**
 * Called after product media HTML is replaced (combined listings, high-variant fetch).
 */
window.initProductPage = function (sectionEl) {
  if (!sectionEl) return;
  initProductMediaSliders(sectionEl);
};

window.initFeaturedProduct = function (sectionEl) {
  if (!sectionEl) return;
  initProductMediaSliders(sectionEl);
};

function getFocusableElements(container) {
  if (!container) return [];

  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );

    var eventList = ["paste", "input"];

    for (event of eventList) {
      this.input.addEventListener(event, function (e) {
        const numberRegex = /^0*?[1-9]\d*$/;

        if (
          numberRegex.test(e.currentTarget.value) ||
          e.currentTarget.value === ""
        ) {
          e.currentTarget.value;
        } else {
          e.currentTarget.value = e.currentTarget.min || 1;
        }
      });
    }

    this.input.addEventListener("focusout", function (e) {
      if (e.currentTarget.value === "") {
        e.currentTarget.value = e.currentTarget.min || 1;
      }
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

// Live volume-pricing unit price shown next to the quantity selector.
// Updates as the shopper types/steps the quantity, without waiting for a cart or section refresh.
class PricePerItem extends HTMLElement {
  constructor() {
    super();
    this.textEl = this.querySelector(".product-form__price-per-item-text");

    try {
      this.priceBreaks = JSON.parse(this.dataset.priceBreaks || "[]").sort(
        (a, b) => a.minimum_quantity - b.minimum_quantity
      );
    } catch (e) {
      this.priceBreaks = [];
    }

    this.cartQuantity = Number(this.dataset.cartQuantity) || 0;

    this.quantityInput = this.closest(".product-form__quantity")?.querySelector(
      ".quantity__input"
    );

    if (this.quantityInput) {
      this.onQuantityChange = this.onQuantityChange.bind(this);
      this.quantityInput.addEventListener("input", this.onQuantityChange);
      this.quantityInput.addEventListener("change", this.onQuantityChange);
    }

    this.render();
  }

  onQuantityChange() {
    this.render();
  }

  render() {
    if (!this.textEl || !this.priceBreaks.length) return;

    const inputQuantity = Number(this.quantityInput?.value) || 0;
    const effectiveQuantity = this.cartQuantity + inputQuantity;

    let tier = this.priceBreaks[0];
    for (const priceBreak of this.priceBreaks) {
      if (effectiveQuantity >= priceBreak.minimum_quantity) {
        tier = priceBreak;
      }
    }

    this.textEl.textContent = `${this.dataset.atText} ${tier.price} ${this.dataset.eachText}`;
  }
}

customElements.define("price-per-item", PricePerItem);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) => {
      if (this.querySelector(".header__localization-button") === button) return;
      if (this.querySelector(".header__localization-lang-button") === button)
        return;
      button.addEventListener("click", this.onCloseButtonClick.bind(this));
    });
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.querySelector(".shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
      this.header.classList.remove("shopify-section-header-hidden");
      this.header.classList.remove("animate");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      if (event.target.closest('[id^="ModalClose-"]')) {
        this.hide();
        return;
      }
      if (event.target.nodeName === "MODAL-DIALOG") this.hide();
    });
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    this.querySelector(".template-popup")?.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");
    button?.addEventListener("click", () => {
      const modalSelector = this.getAttribute("data-modal");
      if (!modalSelector) return;

      const sectionRoot = this.closest(
        ".product-section, .featured-product-section"
      );
      const modal =
        sectionRoot?.querySelector(modalSelector) ||
        document.querySelector(modalSelector);

      modal?.show(button);
    });
  }
}

customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      "click",
      this.loadContent.bind(this)
    );
    if (this.getAttribute("data-autoplay")) {
      this.loadContent();
    }
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      window.pauseAllMedia();
      /*this.appendChild(
				content.querySelector("video, model-viewer, iframe"),
			).focus();*/

      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (this.getAttribute("data-autoplay")) {
              let playPromise = entry.target.play();
              if (playPromise !== undefined) {
                playPromise.then((_) => {}).catch((error) => {});
              }
              //entry.target.play()
            }
          } else {
            entry.target.pause();
          }
        });
      });

      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );

      if (
        deferredElement.nodeName == "VIDEO" ||
        deferredElement.nodeName == "IFRAME"
      ) {
        // force autoplay for safari

        if (this.classList.contains("video-section__media")) {
          let playPromise = deferredElement.play();
          if (playPromise !== undefined) {
            playPromise.then((_) => {}).catch((error) => {});
          }

          videoObserver.observe(deferredElement);
        } else {
          deferredElement.play();
        }
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector(".slider");
    this.sliderItems = this.querySelectorAll(".slider__slide");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    const { slider, sliderItems } = this;

    if (!sliderItems?.length || !slider) return;

    const firstItem = sliderItems[0];
    if (!firstItem) return;

    this.slidesPerPage = Math.floor(slider.clientWidth / firstItem.clientWidth);
    this.totalPages = sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", true);
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", true);
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + this.sliderItems[0].clientWidth
        : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.onVariantChange = this.onVariantChange.bind(this);
    this.onPageShow = this.onPageShow.bind(this);
    this.addEventListener("change", this.onVariantChange);

    this.isHighVariantNeedUpdate = false;
    this.isCombinedListingsNeedUpdate = false;
    this.isStateSyncNeedUpdate = false;
    this.hasInitialCombinedListingSync = false;
  }

  connectedCallback() {
    window.addEventListener("pageshow", this.onPageShow);
    requestAnimationFrame(() => {
      this.syncStateFromPageContext();
    });
  }

  disconnectedCallback() {
    window.removeEventListener("pageshow", this.onPageShow);
  }

  onPageShow(event) {
    if (event.persisted) {
      this.syncStateFromPageContext({ forceFetch: true });
    }
  }

  /**
   * Liquid once used product.variants.size > 250 (never true — variants cap at 250).
   * Prefer data-variants-count + data-is-high-variant-product from product-variant-picker.liquid.
   */
  isHighVariantProductMode() {
    if (this.dataset.isHighVariantProduct === "true") return true;
    if (this.dataset.isHighVariantProduct === "false") return false;
    const count = Number(this.dataset.variantsCount || 0);
    return count > 250;
  }

  normalizePath(path) {
    try {
      const url = new URL(path, window.location.origin);
      const normalizedPath = url.pathname.replace(/\/+$/, "");
      return normalizedPath || "/";
    } catch (e) {
      const normalizedPath = String(path || "").replace(/\/+$/, "");
      return normalizedPath || "/";
    }
  }

  getSelectedVariantData() {
    const selectedVariantEl = this.querySelector("[data-selected-variant]");
    if (!selectedVariantEl?.textContent?.trim()) return null;

    try {
      return JSON.parse(selectedVariantEl.textContent.trim());
    } catch (e) {
      return null;
    }
  }

  isQuickViewContext() {
    return Boolean(this.closest("#quick-view"));
  }

  isMainProductPageContext() {
    const sectionRoot = this.getSectionRoot();
    return (
      sectionRoot?.classList.contains("product-section") &&
      !this.isQuickViewContext()
    );
  }

  hasCombinedListingContext() {
    const sectionRoot = this.getSectionRoot();
    return Boolean(
      this.querySelector("[data-product-url]") ||
        sectionRoot?.querySelector(".linked-products")
    );
  }

  syncControlsToCurrentVariant(variant) {
    if (!variant) return;

    const selectedValues = this.getVariantOptionValues(variant);
    if (!selectedValues.length) return;

    this.currentVariant = variant;
    this.setCheckedInputsBySelectedValues(selectedValues);
    this.querySelectorAll("variant-dropdown-select").forEach((dropdown) => {
      if (typeof dropdown.updateCurrentOption === "function") {
        dropdown.updateCurrentOption(selectedValues);
      }
    });
    this.updateOptions();
    this.syncPickerOptionAvailabilityAfterUpdate();
    this.updateVariantInput();
    this.updatePickupAvailability();
    this.toggleAddButton(!variant.available, window.variantStrings.soldOut);
  }

  fetchCurrentLocationState() {
    const requestUrl = new URL(window.location.href);
    requestUrl.searchParams.set("section_id", this.getSourceSectionId());
    this.isCombinedListingsNeedUpdate = true;
    this.isStateSyncNeedUpdate = true;
    this.renderProductInfo(`${requestUrl.pathname}${requestUrl.search}`);
  }

  syncStateFromPageContext({ forceFetch = false } = {}) {
    if (this.isQuickViewContext()) {
      const selectedVariant = this.getSelectedVariantData();
      if (selectedVariant) {
        this.syncControlsToCurrentVariant(selectedVariant);
      }
      return;
    }

    const shouldSyncFromUrl = this.dataset.updateUrl !== "false";
    const currentPath = this.normalizePath(window.location.pathname);
    const pickerPath = this.normalizePath(this.dataset.url || currentPath);
    const selectedVariant = this.getSelectedVariantData();
    const urlVariantId = new URLSearchParams(window.location.search).get(
      "variant"
    );
    const isPathMismatch = pickerPath !== currentPath;
    const isVariantMismatch =
      Boolean(urlVariantId) &&
      String(selectedVariant?.id || "") !== String(urlVariantId);
    const shouldForceInitialCombinedListingSync =
      !forceFetch &&
      !this.hasInitialCombinedListingSync &&
      shouldSyncFromUrl &&
      this.isMainProductPageContext() &&
      this.hasCombinedListingContext();

    if (shouldForceInitialCombinedListingSync) {
      this.hasInitialCombinedListingSync = true;
      this.fetchCurrentLocationState();
      return;
    }

    if (
      shouldSyncFromUrl &&
      (forceFetch || isPathMismatch || isVariantMismatch)
    ) {
      this.fetchCurrentLocationState();
      return;
    }

    if (selectedVariant) {
      this.syncControlsToCurrentVariant(selectedVariant);
    }
  }

  onVariantChange(event) {
    if (!this.contains(event.target)) return;

    const combinedProductURL = event.target.dataset?.productUrl;
    const isCombinedProductSwitch =
      Boolean(combinedProductURL) &&
      this.normalizePath(combinedProductURL) !==
        this.normalizePath(this.dataset.url || window.location.pathname);

    this.updateOptions();
    // updateMasterId method updates currentVariant from liquid <script data-all-variations-no-high>
    this.updateMasterId();
    if (isCombinedProductSwitch) {
      this.currentVariant = null;
    }
    this.toggleAddButton(true, "");

    this.isHighVariantNeedUpdate = false;
    // -----
    // checking for high-variant and combined products
    // if variant not found in liquid <script data-all-variants-no-high> and product is high-variant
    if (
      isCombinedProductSwitch ||
      (!this.currentVariant && this.isHighVariantProductMode()) ||
      (!this.currentVariant && combinedProductURL)
    ) {
      const selectedValuesIds = this.getSelectedValuesIds();
      this.highVariantRequestUrl = this.createRequestUrl({
        selectedValuesIds: selectedValuesIds,
        combinedProductURL: combinedProductURL,
      });
      if (this.highVariantRequestUrl) {
        this.isHighVariantNeedUpdate = true;
        if (combinedProductURL) {
          this.isCombinedListingsNeedUpdate = true;
        }
      }
    }
    // -----

    if (this.isHighVariantNeedUpdate === false) {
      this.updatePickupAvailability();
      this.updateVariantStatuses();
    }
    this.resetErrorMessage();

    if (!this.currentVariant) {
      // -----
      // for high-variant products
      if (this.isHighVariantNeedUpdate) {
        this.classList.add("high-variant-loading");
        this.renderProductInfo(this.highVariantRequestUrl);
        return;
      }
      // -----

      this.toggleAddButton(true, "");
      this.setUnavailable();
    } else {
      if (
        this.getVariantFeaturedMedia(this.currentVariant) &&
        this.isVariantMediaShowAll()
      ) {
        this.syncVariantMediaSlides();
      }

      if (this.isHighVariantProductMode()) {
        const selectedValuesIds = this.getSelectedValuesIds();
        this.highVariantRequestUrl = this.createRequestUrl({
          selectedValuesIds: selectedValuesIds,
        });
        if (this.highVariantRequestUrl) {
          this.isHighVariantNeedUpdate = true;
          this.classList.add("high-variant-loading");
          this.renderProductInfo(this.highVariantRequestUrl);
          return;
        }
      }

      this.updateURL();
      this.updateVariantInput();
      const requestUrl = this.createRequestUrl({
        currentVariantId: this.currentVariant.id,
      });
      this.renderProductInfo(requestUrl);
    }
  }

  getOptionValueFromControl(control) {
    if (!control) return null;

    // ELD-151: the dropdown sets its hidden input and fires change before its
    // radio is checked, so read the hidden input first or the old value wins.
    const dropdownHidden = control.querySelector(
      'variant-dropdown-select input[type="hidden"]'
    );
    if (dropdownHidden && dropdownHidden.value !== "") {
      return dropdownHidden.value;
    }

    const radioChecked = control.querySelector('input[type="radio"]:checked');
    if (radioChecked) return radioChecked.value;

    const nativeSelect = control.querySelector("select");
    if (nativeSelect) return nativeSelect.value;

    return null;
  }

  updateOptions() {
    const controls = [...this.querySelectorAll(".product-form__controls")];

    controls.sort(
      (a, b) =>
        (Number(a.dataset.optionPosition) || 0) -
        (Number(b.dataset.optionPosition) || 0)
    );

    this.options = controls.map((control) =>
      this.getOptionValueFromControl(control)
    );
  }

  updateMasterId() {
    const variantData = this.getVariantData();
    if (!variantData?.length || !this.options?.length) return;

    this.currentVariant = variantData.find((variant) => {
      const vals = this.getVariantOptionValues(variant);
      if (vals.length !== this.options.length) return false;
      return !vals
        .map((option, index) => this.options[index] === option)
        .includes(false);
    });

    if (this.currentVariant) {
      this.currentVariant = this.enrichVariantFeaturedMedia(
        this.currentVariant
      );
    }
  }

  isHidden(elem) {
    const styles = window.getComputedStyle(elem);
    return styles.display === "none" || styles.visibility === "hidden";
  }

  getVariantFeaturedMedia(variant) {
    if (!variant) return null;
    if (variant.featured_media?.id != null) return variant.featured_media;
    if (variant.featured_image?.id != null) {
      return { id: variant.featured_image.id };
    }
    return null;
  }

  enrichVariantFeaturedMedia(variant) {
    if (!variant) return variant;

    if (variant.featured_media?.id != null) return variant;

    const selectedVariant = this.getSelectedVariantData();
    if (
      selectedVariant?.id === variant.id &&
      selectedVariant?.featured_media?.id != null
    ) {
      variant.featured_media = selectedVariant.featured_media;
      return variant;
    }

    const fromVariantData = this.getVariantData().find(
      (entry) => String(entry.id) === String(variant.id)
    );
    if (fromVariantData?.featured_media?.id != null) {
      variant.featured_media = fromVariantData.featured_media;
    }

    return variant;
  }

  getVariantMediaDisplayMode() {
    return this.dataset.variantMediaDisplay || "show_all";
  }

  isVariantMediaShowAll() {
    return this.getVariantMediaDisplayMode() === "show_all";
  }

  fetchedMediaHasContent(mediaSource) {
    if (!mediaSource) return false;

    const mediaList = mediaSource.querySelector(".product__media-list");
    if (mediaList?.children?.length > 0) return true;

    return Boolean(
      mediaSource.querySelector(
        ".product__media-item .placeholder-svg, .product__media-item .product__media"
      )
    );
  }

  shouldReplaceProductMediaHtmlFromFetch() {
    if (this.isCombinedListingsNeedUpdate) return true;
    return !this.isVariantMediaShowAll();
  }

  findMediaElement(mediaContainer, mediaId) {
    if (!mediaContainer || mediaId == null) return null;

    const sectionId = this.dataset.section;
    return (
      mediaContainer.querySelector(
        `[data-media-id="${sectionId}-${mediaId}"]`
      ) || mediaContainer.querySelector(`[data-media-id="${mediaId}"]`)
    );
  }

  findMediaSubElement(mediaContainer, mediaId) {
    if (!mediaContainer || mediaId == null) return null;

    const sectionId = this.dataset.section;
    return (
      mediaContainer.querySelector(
        `[data-media-sub-id="${sectionId}-${mediaId}"]`
      ) || mediaContainer.querySelector(`[data-media-sub-id="${mediaId}"]`)
    );
  }

  findMediaElementForVariant(mediaContainer, variant) {
    if (!mediaContainer || !variant) return null;

    const sectionId = this.dataset.section;
    const featuredMedia = this.getVariantFeaturedMedia(variant);

    if (featuredMedia?.id != null) {
      const byFeaturedMedia = this.findMediaElement(
        mediaContainer,
        featuredMedia.id
      );
      if (byFeaturedMedia) return byFeaturedMedia;
    }

    const imageId = variant.featured_image?.id;
    if (imageId != null) {
      const byImageId = this.findMediaElement(mediaContainer, imageId);
      if (byImageId) return byImageId;

      for (const item of mediaContainer.querySelectorAll(
        ".product__media-item[data-media-id]"
      )) {
        const dataMediaId = item.getAttribute("data-media-id") || "";
        if (
          dataMediaId === `${sectionId}-${imageId}` ||
          dataMediaId.endsWith(`-${imageId}`)
        ) {
          return item;
        }
      }
    }

    return mediaContainer.querySelector(".product__media-item--variant");
  }

  findMediaSubElementForVariant(mediaContainer, variant) {
    const mainSlide = this.findMediaElementForVariant(mediaContainer, variant);
    if (!mainSlide) return null;

    const dataMediaId = mainSlide.getAttribute("data-media-id") || "";
    const mediaId = dataMediaId.includes("-")
      ? dataMediaId.split("-").pop()
      : dataMediaId;

    return this.findMediaSubElement(mediaContainer, mediaId);
  }

  goToSlickSlide($slider, slideEl) {
    if (!$slider?.length || !slideEl) return false;
    // ELD-151: see initProductMediaSliders.
    if (typeof $slider.slick !== "function") return false;

    const $slides = $slider.find(
      ".product__media-item, .product__media-subitem"
    );
    const index = $slides.index(slideEl);

    if (index < 0 || !$slider.hasClass("slick-initialized")) return false;

    $slider.slick("slickGoTo", index, false);
    return true;
  }

  syncVariantMediaAfterFetch() {
    if (!this.currentVariant) return;

    if (this.isVariantMediaShowAll()) {
      this.syncVariantMediaSlides();
    }
  }

  syncVariantMediaSlides() {
    if (!this.currentVariant) return false;

    this.currentVariant = this.enrichVariantFeaturedMedia(this.currentVariant);

    const mediaContainer = this.getMediaContainer();
    if (!mediaContainer) return false;

    const mainSlide = this.findMediaElementForVariant(
      mediaContainer,
      this.currentVariant
    );
    if (!mainSlide) return false;

    const subSlide = this.findMediaSubElementForVariant(
      mediaContainer,
      this.currentVariant
    );
    const $ = window.jQuery;

    if ($) {
      const $list = $(mediaContainer).find(".product__media-list").first();
      const $sub = $(mediaContainer).find(".product__media-sublist").first();
      const mainNavigated = this.goToSlickSlide($list, mainSlide);

      if (mainNavigated) {
        if (subSlide) {
          this.goToSlickSlide($sub, subSlide);
        }
        refreshProductMediaSlickPositionsAfterRender(mediaContainer);
        return true;
      }
    }

    destroyProductMediaSliders(mediaContainer);
    mainSlide.parentElement?.prepend(mainSlide);
    if (subSlide) {
      subSlide.parentElement?.prepend(subSlide);
    }
    initProductMediaSliders(mediaContainer);
    return true;
  }

  updateMedia() {
    this.syncVariantMediaSlides();
  }

  updateMediaSub() {
    this.syncVariantMediaSlides();
  }

  updateURL() {
    if (this.dataset.updateUrl === "false") return;
    const newUrl = this.currentVariant
      ? `${this.dataset.url}?variant=${this.currentVariant.id}`
      : this.dataset.url;

    window.history.replaceState({}, "", newUrl);
  }

  getProductFormScopeSelector() {
    return `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`;
  }

  setVariantInputState(isEnabled) {
    const productForms = this.getProductForms();
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;

      input.disabled = !isEnabled;
      if (!isEnabled) {
        input.value = "";
      }
    });
  }

  updateVariantInput() {
    const productForms = this.getProductForms();
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;
      input.disabled = false;
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    publish(PUB_SUB_EVENTS.variantChange, {
      data: {
        sectionId: this.dataset.section,
        variant: this.currentVariant,
      },
    });
  }

  syncPickerOptionAvailabilityAfterUpdate() {
    if (this.isHighVariantProductMode()) {
      this.syncRadioDisabledFromLiquidClasses();
      return;
    }
    this.updateVariantStatuses();
  }

  syncRadioDisabledFromLiquidClasses() {
    this.querySelectorAll('input[type="radio"]').forEach((input) => {
      // Sold-out options should remain clickable.
      // Keep visual state via `.disabled` class, but never block interaction.
      input.disabled = false;
      input.removeAttribute("disabled");
    });
  }

  updateVariantStatuses() {
    // High-variant products only expose a truncated variant list in Liquid/JSON.
    // Recomputing availability from that subset can mark valid options as sold out.
    if (this.isHighVariantProductMode()) return;

    const variantData = this.getVariantData();
    if (!variantData?.length) return;

    const inputWrappers = [...this.querySelectorAll(".product-form__controls")];
    inputWrappers.sort(
      (a, b) =>
        (Number(a.dataset.optionPosition) || 0) -
        (Number(b.dataset.optionPosition) || 0)
    );

    const firstVal = this.getOptionValueFromControl(inputWrappers[0]);
    if (firstVal == null) return;

    const selectedOptionOneVariants = variantData.filter((variant) => {
      const vals = this.getVariantOptionValues(variant);
      return vals[0] === firstVal;
    });

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected = this.getOptionValueFromControl(
        inputWrappers[index - 1]
      );
      if (previousOptionSelected == null) return;

      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => {
          const vals = this.getVariantOptionValues(variant);
          return (
            variant.available && vals[index - 1] === previousOptionSelected
          );
        })
        .map((variantOption) => {
          const vals = this.getVariantOptionValues(variantOption);
          return vals[index];
        });
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      const isAvailable = listOfAvailableOptions.includes(
        input.getAttribute("value")
      );

      if (isAvailable) {
        if (input.tagName === "OPTION") {
          input.innerText = input.getAttribute("value");
          input.disabled = false;
        } else if (input.tagName === "INPUT") {
          input.classList.remove("disabled");
          input.disabled = false;
          input.removeAttribute("disabled");
        }
      } else {
        if (input.tagName === "OPTION") {
          input.innerText =
            window.variantStrings.unavailable_with_option.replace(
              "[value]",
              input.getAttribute("value")
            );
          // Do not disable sold-out option to keep selection possible.
          input.disabled = false;
        } else if (input.tagName === "INPUT") {
          input.classList.add("disabled");
          // Do not disable sold-out input to keep selection possible.
          input.disabled = false;
          input.removeAttribute("disabled");
        }
      }
    });
  }

  setCheckedInputsBySelectedValues(selectedValues) {
    const inputWrappers = [...this.querySelectorAll(".product-form__controls")];

    inputWrappers.forEach((groupEl, index) => {
      const selectedValue = selectedValues[index];
      if (!selectedValue) return;

      const inputs = [...groupEl.querySelectorAll('input[type="radio"]')];

      inputs.forEach((input) => {
        const shouldBeChecked = input.value === selectedValue;
        input.checked = shouldBeChecked;
        if (shouldBeChecked) {
          input.setAttribute("checked", "");
        } else {
          input.removeAttribute("checked");
        }
      });
    });
  }

  getSelectedValues() {
    const controls = [...this.querySelectorAll(".product-form__controls")];

    controls.sort(
      (a, b) =>
        (Number(a.dataset.optionPosition) || 0) -
        (Number(b.dataset.optionPosition) || 0)
    );

    return controls.map((control) => this.getOptionValueFromControl(control));
  }

  updatePickupAvailability() {
    if (this.isQuickViewContext()) return;

    const sectionRoot = this.getSectionRoot();
    const pickUpAvailability =
      sectionRoot?.querySelector("pickup-availability") ||
      document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.dataset.variantId = this.currentVariant.id;
      pickUpAvailability.setAttribute("available", "");

      if (typeof pickUpAvailability.fetchAvailability === "function") {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
        return;
      }

      if (window.customElements?.whenDefined) {
        window.customElements.whenDefined("pickup-availability").then(() => {
          const upgradedPickupAvailability =
            sectionRoot?.querySelector("pickup-availability") ||
            document.querySelector("pickup-availability");
          if (
            upgradedPickupAvailability &&
            typeof upgradedPickupAvailability.fetchAvailability === "function"
          ) {
            upgradedPickupAvailability.dataset.variantId =
              this.currentVariant.id;
            upgradedPickupAvailability.setAttribute("available", "");
            upgradedPickupAvailability.fetchAvailability(
              this.currentVariant.id
            );
          }
        });
      }
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo(requestUrl) {
    this.abortController?.abort();
    this.abortController = new AbortController();

    fetch(requestUrl, { signal: this.abortController.signal })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Section fetch failed: ${response.status} ${response.statusText}`
          );
        }
        return response.text();
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        try {
          this.setCurrentVariantAfterFetch(html);
        } catch (err) {}

        // -----
        // for high-variant products
        // and if variant not found in liquid <script data-all-variants-no-high>
        // but it was found after a request with the option_values parameter
        if (this.isHighVariantNeedUpdate) {
          try {
            this.updatePickerInnerHtml(html);
            this.syncPickerOptionAvailabilityAfterUpdate();
            this.updateURL();
            this.updatePickupAvailability();
            if (this.currentVariant) {
              this.updateVariantInput();
            }
          } catch (err) {}
        }
        // -----

        if (this.isStateSyncNeedUpdate) {
          try {
            this.updatePickerInnerHtml(html);
            if (this.currentVariant) {
              this.syncControlsToCurrentVariant(this.currentVariant);
            } else {
              this.syncPickerOptionAvailabilityAfterUpdate();
            }
          } catch (err) {}
        }

        this.updateElementsAfterFetch(html);
        this.syncVariantMediaAfterFetch();

        if (!this.currentVariant) {
          this.toggleAddButton(true, "");
          this.setUnavailable();
        } else {
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut
          );
        }
      })
      .catch((error) => {
        if (error.name === "AbortError") {
          console.info("Fetch aborted by user");
        } else {
          console.error(error);
        }
      })
      .finally(() => {
        this.isHighVariantNeedUpdate = false;
        this.isStateSyncNeedUpdate = false;
        this.classList.remove("high-variant-loading");
      });
  }

  toggleAddButton(disable = true, text) {
    this.getProductForms().forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      if (!addButton) return;

      const labelTarget =
        addButton.querySelector(".button__label") ||
        addButton.querySelector("span:not(.visually-hidden)") ||
        addButton;

      if (disable) {
        addButton.setAttribute("disabled", true);
        addButton.setAttribute("aria-disabled", "true");
        if (text) {
          labelTarget.textContent = text;
        }
      } else {
        addButton.removeAttribute("disabled");
        addButton.removeAttribute("aria-disabled");
        labelTarget.textContent = window.variantStrings.addToCart;
      }
    });
  }

  resetErrorMessage() {
    const productForms = this.getProductForms();
    productForms.forEach((productForm) => {
      const parentEl = productForm.closest("product-form");
      if (parentEl) {
        const errorWrapperEl = parentEl.querySelector(
          ".product-form__error-message-wrapper"
        );
        const errorTextEl = errorWrapperEl?.querySelector(
          ".product-form__error-message"
        );
        if (!errorWrapperEl || !errorTextEl) return;
        errorWrapperEl.setAttribute("hidden", true);
        errorTextEl.textContent = "";
      }
    });
  }

  setUnavailable() {
    const price = this.getScopedElementById(`price-${this.dataset.section}`);
    const inventory = this.getScopedElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = this.getScopedElementById(`Sku-${this.dataset.section}`);
    const colorNameDestinations = this.getScopedElementsByIdPrefix(
      `ColorName-${this.dataset.section}`
    );

    this.setVariantInputState(false);
    this.toggleAddButton(true, window.variantStrings.unavailable);
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
    colorNameDestinations.forEach((colorNameDestination) => {
      colorNameDestination.classList.add("visibility-hidden");
    });
  }

  getVariantData() {
    const el = this.querySelector("[data-all-variants-no-high]");
    if (!el?.textContent?.trim()) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  /**
   * Liquid `product.variants | json` often leaves `variant.options` as [] while
   * option1–option3 still hold the values — empty `options` made every variant "match"
   * (first variant always won), blocking high-variant fetches.
   */
  getVariantOptionValues(variant) {
    if (!variant) return [];
    const raw = variant.options;
    if (Array.isArray(raw) && raw.length > 0) {
      return raw
        .map((opt) => {
          if (opt == null || opt === "") return null;
          if (typeof opt === "string") return opt;
          if (typeof opt === "object" && opt != null && "name" in opt) {
            return opt.name;
          }
          return String(opt);
        })
        .filter((v) => v != null && v !== "");
    }
    return [variant.option1, variant.option2, variant.option3].filter(
      (v) => v != null && v !== ""
    );
  }

  getSourceSectionId() {
    return this.dataset.originalSection || this.dataset.section;
  }

  getSectionRoot() {
    return this.closest(".product-section, .featured-product-section");
  }

  syncProductLayoutClasses(html) {
    const sectionRoot = this.getSectionRoot();
    if (!sectionRoot) return;

    const productRootDestination = sectionRoot.querySelector(
      ".featured-product.product, .product"
    );
    const productRootSource = html.querySelector(
      ".featured-product.product, .product"
    );
    if (productRootDestination && productRootSource) {
      productRootDestination.className = productRootSource.className;
    }

    const infoWrapperDestination = sectionRoot.querySelector(
      ".product__info-wrapper"
    );
    const infoWrapperSource = html.querySelector(".product__info-wrapper");
    if (infoWrapperDestination && infoWrapperSource) {
      infoWrapperDestination.className = infoWrapperSource.className;
    }

    const mediaWrapperDestination = sectionRoot.querySelector(
      ".product__media-wrapper"
    );
    const mediaWrapperSource = html.querySelector(".product__media-wrapper");
    if (mediaWrapperDestination && mediaWrapperSource) {
      mediaWrapperDestination.className = mediaWrapperSource.className;
      ["data-gallery-ratio-desktop", "data-gallery-ratio-mobile"].forEach(
        (attributeName) => {
          const nextValue = mediaWrapperSource.getAttribute(attributeName);
          if (nextValue == null) {
            mediaWrapperDestination.removeAttribute(attributeName);
          } else {
            mediaWrapperDestination.setAttribute(attributeName, nextValue);
          }
        }
      );
    }
  }

  getScopedElementById(id) {
    const sectionRoot = this.getSectionRoot();
    return (
      sectionRoot?.querySelector(`[id="${id}"]`) || document.getElementById(id)
    );
  }

  getScopedElementsByIdPrefix(prefix) {
    const sectionRoot = this.getSectionRoot();
    const elements = sectionRoot?.querySelectorAll(`[id^="${prefix}"]`);
    if (elements) {
      return [...elements];
    }

    return [...document.querySelectorAll(`[id^="${prefix}"]`)];
  }

  getMediaContainer(sectionId = this.dataset.section) {
    const sectionRoot = this.getSectionRoot();
    return (
      sectionRoot?.querySelector(
        `[data-section="product-media-${sectionId}"]`
      ) || document.querySelector(`[data-section="product-media-${sectionId}"]`)
    );
  }

  getProductForms() {
    const sectionRoot = this.getSectionRoot();
    return sectionRoot
      ? [...sectionRoot.querySelectorAll(this.getProductFormScopeSelector())]
      : [...document.querySelectorAll(this.getProductFormScopeSelector())];
  }

  syncVariantPickerAttributes(variantPickerSource) {
    if (!variantPickerSource) return;

    const attributesToSync = [
      "data-url",
      "data-variants-count",
      "data-is-high-variant-product",
      "data-update-url",
      "data-variant-media-display",
    ];

    attributesToSync.forEach((attributeName) => {
      const nextValue = variantPickerSource.getAttribute(attributeName);
      if (nextValue == null) {
        // Keep media display mode when fetch omits it — removing it forces
        // empty gallery swaps on every variant change.
        if (attributeName === "data-variant-media-display") return;
        this.removeAttribute(attributeName);
      } else {
        this.setAttribute(attributeName, nextValue);
      }
    });
  }

  updateProductLinks() {
    const productUrl = this.dataset.url;
    if (!productUrl) return;

    const sectionRoot = this.getSectionRoot();
    if (!sectionRoot) return;

    sectionRoot
      .querySelectorAll(".product-form__buttons-more")
      .forEach((linkEl) => {
        linkEl.setAttribute("href", productUrl);
      });
  }

  updateElementsAfterFetch(html) {
    if (!html?.querySelector) return;

    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.getSourceSectionId();

    this.syncProductLayoutClasses(html);

    // price
    const priceDestination = this.getScopedElementById(
      `price-${currentSectionId}`
    );

    const priceSource = html.getElementById(`price-${sourceSectionId}`);
    if (priceSource && priceDestination) {
      priceDestination.innerHTML = priceSource.innerHTML;
      priceDestination.classList.remove("visibility-hidden");
    }

    // quantity selector + B2B volume pricing / quantity rules elements
    // https://help.shopify.com/en/manual/b2b/catalogs/quantity-pricing
    const quantityDestination = this.getScopedElementById(
      `ProductQuantity-${currentSectionId}`
    );
    const quantitySource = html.getElementById(
      `ProductQuantity-${sourceSectionId}`
    );
    if (quantitySource && quantityDestination) {
      quantityDestination.innerHTML = quantitySource.innerHTML;
      quantityDestination.dataset.hasQuantityPricing =
        quantitySource.dataset.hasQuantityPricing;
    } else if (!quantitySource && quantityDestination) {
      quantityDestination.remove();
    }

    // title
    const titleSource = html.getElementById(`ProductTitle-${sourceSectionId}`);
    const titleDestination = this.getScopedElementById(
      `ProductTitle-${currentSectionId}`
    );
    if (titleSource && titleDestination) {
      titleDestination.innerHTML = titleSource.innerHTML;
    }

    // Breadcrumb product title (layout): not present in section HTML response — sync from fetched ProductTitle block
    const crumbDestination =
      this.getScopedElementById("ProductBreadcrumbTitle") ||
      this.getScopedElementById(`ProductBreadcrumbTitle-${currentSectionId}`);
    const productTitleBlock = html.getElementById(
      `ProductTitle-${sourceSectionId}`
    );
    if (crumbDestination && productTitleBlock) {
      const titleHeading = productTitleBlock.querySelector(
        "h1.product__title, .product__title, h1"
      );
      const nextText = (titleHeading || productTitleBlock).textContent.trim();
      if (nextText) {
        crumbDestination.textContent = nextText;
      }
    }

    // inventory
    const inventorySource = html.getElementById(`Inventory-${sourceSectionId}`);
    const inventoryDestination = this.getScopedElementById(
      `Inventory-${currentSectionId}`
    );
    if (inventorySource && inventoryDestination) {
      inventoryDestination.innerHTML = inventorySource.innerHTML;
      inventoryDestination.classList.toggle(
        "visibility-hidden",
        inventorySource.innerText === ""
      );
    }

    // sku
    const skuSource = html.getElementById(`Sku-${sourceSectionId}`);
    const skuDestination = this.getScopedElementById(`Sku-${currentSectionId}`);
    if (skuSource && skuDestination) {
      skuDestination.innerHTML = skuSource.innerHTML;
      skuDestination.classList.toggle(
        "visibility-hidden",
        skuSource.classList.contains("visibility-hidden")
      );
    }

    // description
    const descriptionSource = html.getElementById(
      `ProductDescription-${sourceSectionId}`
    );
    const descriptionDestination = this.getScopedElementById(
      `ProductDescription-${currentSectionId}`
    );
    if (descriptionDestination) {
      descriptionDestination.innerHTML = descriptionSource
        ? descriptionSource.innerHTML
        : "";
    }

    // tags
    const tagsSource = html.getElementById(`ProductTags-${sourceSectionId}`);
    const tagsDestination = this.getScopedElementById(
      `ProductTags-${currentSectionId}`
    );
    if (tagsDestination) {
      tagsDestination.innerHTML = tagsSource ? tagsSource.innerHTML : "";
    }

    // linked products
    const linkedProductsSource = html.getElementById(
      `LinkedProducts-${sourceSectionId}`
    );
    const linkedProductsDestination = this.getScopedElementById(
      `LinkedProducts-${currentSectionId}`
    );
    if (linkedProductsDestination) {
      linkedProductsDestination.innerHTML = linkedProductsSource
        ? linkedProductsSource.innerHTML
        : "";
    }

    // complementary products
    const complementarySource = html.getElementById(
      `ProductComplementary-${sourceSectionId}`
    );
    const complementaryDestination = this.getScopedElementById(
      `ProductComplementary-${currentSectionId}`
    );
    if (complementaryDestination) {
      complementaryDestination.innerHTML = complementarySource
        ? complementarySource.innerHTML
        : "";
    }

    // buy buttons / gift card recipient / pickup availability
    const buyButtonsSource = html.getElementById(
      `ProductBuyButtons-${sourceSectionId}`
    );
    const buyButtonsDestination = this.getScopedElementById(
      `ProductBuyButtons-${currentSectionId}`
    );
    if (buyButtonsSource && buyButtonsDestination) {
      const buyButtonsFragment = buyButtonsSource.cloneNode(true);
      buyButtonsFragment
        .querySelectorAll("script")
        .forEach((node) => node.remove());

      if (this.isQuickViewContext()) {
        buyButtonsFragment
          .querySelectorAll(
            "pickup-availability, pickup-availability-drawer, .pickup-availability-preview"
          )
          .forEach((node) => node.remove());
      }

      buyButtonsDestination.innerHTML = buyButtonsFragment.innerHTML;
    }

    // zoom / media modal content
    const productModalSource = html.getElementById(
      `ProductModal-${sourceSectionId}`
    );
    const productModalDestination = this.getScopedElementById(
      `ProductModal-${currentSectionId}`
    );
    if (productModalSource && productModalDestination) {
      productModalDestination.innerHTML = productModalSource.innerHTML;
    }

    // color swatches label
    const colorNameSources = html.querySelectorAll(
      `[id^="ColorName-${sourceSectionId}"]`
    );
    const colorNameDestinations = this.getScopedElementsByIdPrefix(
      `ColorName-${currentSectionId}`
    );
    if (colorNameSources?.length === colorNameDestinations?.length) {
      colorNameDestinations.forEach((colorNameDestination, index) => {
        colorNameDestination.classList.remove("visibility-hidden");
        colorNameDestination.innerHTML = colorNameSources[index].innerHTML;
      });
    }

    // variant image swatches
    if (this.isHighVariantNeedUpdate !== true) {
      const variantSwatchesSource = html.querySelector(
        `#variant-picker-${sourceSectionId} [data-is-variant-image-swatch="true"]`
      );
      const variantSwatchesDestination = this.querySelector(
        '[data-is-variant-image-swatch="true"]'
      );
      if (variantSwatchesSource && variantSwatchesDestination) {
        variantSwatchesDestination.innerHTML = variantSwatchesSource.innerHTML;
      }
    }

    // product media — show_all keeps existing gallery and only reorders slides
    if (this.shouldReplaceProductMediaHtmlFromFetch()) {
      const mediaSource = html.querySelector(
        `[data-section="product-media-${sourceSectionId}"]`
      );
      const mediaDestination = this.getMediaContainer(currentSectionId);
      if (mediaSource && mediaDestination) {
        if (!this.fetchedMediaHasContent(mediaSource)) {
          this.syncVariantMediaAfterFetch();
        } else {
          destroyProductMediaSliders(mediaDestination);

          mediaDestination.innerHTML = mediaSource.innerHTML;

          const sectionRoot = this.getSectionRoot();
          if (
            sectionRoot?.classList.contains("featured-product-section") &&
            typeof window.initFeaturedProduct === "function"
          ) {
            window.initFeaturedProduct(sectionRoot);
          } else if (
            sectionRoot &&
            typeof window.initProductPage === "function"
          ) {
            window.initProductPage(sectionRoot);
          }
        }

        this.isCombinedListingsNeedUpdate = false;
      }
    }

    this.updateProductLinks();
  }

  // methods for high variant products
  getSelectedValuesIds() {
    const controls = [...this.querySelectorAll(".product-form__controls")];

    controls.sort(
      (a, b) =>
        (Number(a.dataset.optionPosition) || 0) -
        (Number(b.dataset.optionPosition) || 0)
    );

    return controls.map((control) => {
      const checkedInput = control.querySelector('input[type="radio"]:checked');
      if (checkedInput?.dataset?.optionValueId) {
        return checkedInput.dataset.optionValueId;
      }

      const hidden = control.querySelector(
        'variant-dropdown-select input[type="hidden"]'
      );
      if (!hidden?.value) return null;

      for (const radio of control.querySelectorAll('input[type="radio"]')) {
        if (radio.value === hidden.value && radio.dataset?.optionValueId) {
          return radio.dataset.optionValueId;
        }
      }
      return null;
    });
  }

  createRequestUrl({
    currentVariantId = "",
    selectedValuesIds = [],
    combinedProductURL = "",
  }) {
    const productUrl = combinedProductURL || `${this.dataset.url}`;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    if (currentVariantId) {
      return `${productUrl}?variant=${currentVariantId}&section_id=${sectionId}`;
    }

    // -----
    // for high-variant products
    // and if variant not found in liquid <script data-all-variants-no-high>
    // Match working theme: any non-empty selection builds the URL (do not require
    // id count === option groups — that blocked fetches when one id was missing).
    if (selectedValuesIds && selectedValuesIds.length) {
      const ids = selectedValuesIds.filter(
        (id) => id != null && String(id).length > 0
      );
      if (!ids.length) {
        return undefined;
      }
      const params = [];
      params.push(`section_id=${sectionId}`);
      params.push(`option_values=${ids.join(",")}`);
      return `${productUrl}?${params.join("&")}`;
    }
    // -----
  }

  setCurrentVariantAfterFetch(html) {
    const sourceSectionId = this.getSourceSectionId();

    const variantPickerSource = html.getElementById(
      `variant-picker-${sourceSectionId}`
    );
    if (!variantPickerSource) {
      return;
    }

    this.syncVariantPickerAttributes(variantPickerSource);

    const newVariantDataEl = variantPickerSource.querySelector(
      "[data-selected-variant]"
    );
    if (!newVariantDataEl) {
      return;
    }

    const newVariantData = newVariantDataEl.textContent.trim();
    let selectedVariant = null;
    if (newVariantData) {
      try {
        selectedVariant = JSON.parse(newVariantData);
      } catch (e) {
        selectedVariant = null;
      }
    }

    this.currentVariant = selectedVariant;
    if (this.currentVariant) {
      this.currentVariant = this.enrichVariantFeaturedMedia(
        this.currentVariant
      );
    }

    const oldEl = this.querySelector("[data-selected-variant]");
    if (oldEl) {
      oldEl.textContent = newVariantData;
    }
  }

  updatePickerInnerHtml(html) {
    const sourceSectionId = this.getSourceSectionId();

    const variantPickerSource = html.getElementById(
      `variant-picker-${sourceSectionId}`
    );

    if (variantPickerSource) {
      this.syncVariantPickerAttributes(variantPickerSource);
      this.innerHTML = variantPickerSource.innerHTML;
      this.syncPickerOptionAvailabilityAfterUpdate();
    }
  }
}

if (!customElements.get("variant-selects")) {
  customElements.define("variant-selects", VariantSelects);
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
}

if (!customElements.get("variant-radios")) {
  customElements.define("variant-radios", VariantRadios);
}

class VariantDropdownSelect extends HTMLElement {
  constructor() {
    super();

    this.currentEl = this.querySelector(".dropdown-select__current");
    this.optionsWrapperEl = this.querySelector(".dropdown-select__options");
    this.hiddenInput = this.querySelector("input[type='hidden']");
    if (!this.currentEl || !this.optionsWrapperEl || !this.hiddenInput) return;

    this.optionsEls = Array.from(this.optionsWrapperEl.querySelectorAll("li"));
    this.inputs = Array.from(this.optionsWrapperEl.querySelectorAll("input"));
    this.hasColorSwatch = this.currentEl?.classList?.contains(
      "dropdown-select__current--with-color"
    );
    this.isActive = false;

    this.optionPosition = this.getOptionPosition();
    this._onCurrentClick = this.onCurrentClick.bind(this);
    this._onKeyUp = this.onKeyUp.bind(this);
    this._onOptionsClick = this.onClickOption.bind(this);
    this._onKeyUpOptions = this.onKeyUpOptions.bind(this);
    this._onOutsideClick = this.onOutsideClick.bind(this);
  }

  connectedCallback() {
    this.currentEl.addEventListener("click", this._onCurrentClick);
    this.currentEl.addEventListener("keyup", this._onKeyUp);
    this.currentEl.addEventListener("dblclick", this.preventDoubleClick);
    this.optionsWrapperEl.addEventListener("click", this._onOptionsClick);
    this.optionsWrapperEl.addEventListener("keyup", this._onKeyUpOptions);
    document.addEventListener("click", this._onOutsideClick);
  }

  disconnectedCallback() {
    this.currentEl.removeEventListener("click", this._onCurrentClick);
    this.currentEl.removeEventListener("keyup", this._onKeyUp);
    this.currentEl.removeEventListener("dblclick", this.preventDoubleClick);
    this.optionsWrapperEl.removeEventListener("click", this._onOptionsClick);
    this.optionsWrapperEl.removeEventListener("keyup", this._onKeyUpOptions);
    document.removeEventListener("click", this._onOutsideClick);
  }

  onCurrentClick(event) {
    event.stopPropagation();
    if (this.isActive) {
      this.onClose();
    } else {
      this.onOpen();
    }
  }

  onKeyUp(event) {
    if (event.code?.toUpperCase() === "ENTER") {
      event.preventDefault();
      event.stopPropagation();
      if (this.isActive) {
        this.onClose();
      } else {
        this.onOpen();
      }
    }
  }

  preventDoubleClick(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  onClickOption(event) {
    const optionEl = event.target.closest("li");
    const currentValueEl = this.currentEl.querySelector(
      "[data-dropdown-current-value]"
    );

    if (
      !optionEl ||
      !currentValueEl ||
      !this.optionsWrapperEl.contains(optionEl)
    ) {
      event.preventDefault();
      return;
    }

    const newValue = optionEl.dataset.value;

    currentValueEl.textContent = newValue;
    this.hiddenInput.value = newValue;

    if (this.hasColorSwatch) {
      const newColor = optionEl.dataset.color;
      this.hiddenInput.dataset.colorSwatch = newColor;
      this.currentEl.style.setProperty("--swatch-color", newColor);
    }

    this.hiddenInput.dispatchEvent(new Event("change", { bubbles: true }));

    this.inputs.forEach((el) => el.removeAttribute("checked"));
    if (event.target.tagName === "INPUT") {
      event.target.setAttribute("checked", "true");
    }

    this.onClose();
    this.currentEl.focus();
  }

  onKeyUpOptions(event) {
    if (event.code === "Escape" && this.isActive) {
      event.preventDefault();
      this.onClose();
      this.currentEl.focus();
    }
  }

  onOpen() {
    document.querySelectorAll("variant-dropdown-select").forEach((dropdown) => {
      if (dropdown !== this && typeof dropdown.onClose === "function") {
        dropdown.onClose();
      }
    });

    this.optionsWrapperEl.classList.add("active");
    this.currentEl.setAttribute("aria-expanded", "true");
    this.isActive = true;

    const currentIndex = this.inputs.findIndex((inp) =>
      inp.hasAttribute("checked")
    );
    this.inputs[currentIndex >= 0 ? currentIndex : 0]?.focus();
  }

  onClose() {
    this.optionsWrapperEl.classList.remove("active");
    this.currentEl.setAttribute("aria-expanded", "false");
    this.isActive = false;
  }

  onOutsideClick(event) {
    if (!this.isActive || this.contains(event.target)) return;
    this.onClose();
  }

  getOptionPosition() {
    const parentFieldset = this.closest(".product-form__controls");
    return Number(parentFieldset?.dataset?.optionPosition || -1);
  }

  updateCurrentOption(selectedValues = []) {
    // Method is used to synchronize after changes options in sticky bar.
    if (this.optionPosition === -1) return;
    const currentValueEl = this.currentEl.querySelector(
      "[data-dropdown-current-value]"
    );

    if (!currentValueEl || !selectedValues || !selectedValues.length) return;

    const newValue = selectedValues[this.optionPosition - 1];

    currentValueEl.textContent = newValue;
    this.hiddenInput.value = newValue;

    this.optionsEls.forEach((optionEl) => {
      const liDataValue = optionEl.dataset.value;
      if (newValue === liDataValue && this.hasColorSwatch) {
        const newColor = optionEl.dataset.color;
        this.hiddenInput.dataset.colorSwatch = newColor;
        this.currentEl.style.setProperty("--swatch-color", newColor);
      }
    });
  }
}

if (!customElements.get("variant-dropdown-select")) {
  customElements.define("variant-dropdown-select", VariantDropdownSelect);
}

(function () {
  const header = () => {
    const submenuDetails = document.querySelectorAll(
      ".header__submenu li details"
    );
    const mainHeader = document.querySelector(".shopify-section-header");

    submenuDetails.forEach((targetDetail) => {
      targetDetail.addEventListener("click", () => {
        submenuDetails.forEach((detail) => {
          if (detail !== targetDetail) {
            detail.removeAttribute("open");
          }
        });
      });
    });

    initMegaSubmenu(mainHeader);
  };

  const initMegaSubmenu = (header) => {
    const megaSubmenuLinks = header.querySelectorAll(".list-menu--megasubmenu");
    if (!megaSubmenuLinks || !megaSubmenuLinks.length) return;
    megaSubmenuLinks.forEach((link) => {
      const tabs = link.querySelectorAll(".mega-submenu__tab");
      const submenus = link.querySelectorAll(".mega-submenu__submenu");
      const onToggle = (event) => {
        const tab = event.target;
        if (!tab || !tab.classList.contains("mega-submenu__tab")) return;
        const tabId = tab.dataset.tabId;
        tabs.forEach((tab) => {
          tab.classList.remove("active");
        });
        tab.classList.add("active");
        submenus.forEach((submenu) => {
          submenu.classList.remove("active");
          if (submenu.dataset.tabId === tabId) {
            submenu.classList.add("active");
          }
        });
      };
      tabs.forEach((tab) => {
        tab.addEventListener("click", onToggle);
        tab.addEventListener("mouseenter", onToggle);
      });
    });
  };

  document.addEventListener("shopify:section:load", header);

  header();
})();

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

window.onload = function () {
  const coolimageScript = document.querySelectorAll(
    'script[src*="cool-image-magnifier"]'
  );
  let coolimageGallery = document.querySelector(".product__media-wrapper");

  if (coolimageScript.length > 0 && coolimageGallery) {
    coolimageGallery.classList.add("cool-image-custom");
  }
};

// global.js loads before jQuery (both defer), so a top-level $ threw here and
// stopped the rest of this file. Wait until the deferred scripts have run.
document.addEventListener("DOMContentLoaded", function () {
  bindProductMediaImageLoadRefresh(document);
  $(document).on("init", ".product__media-list", function () {
    refreshProductMediaSlickPositionsAfterRender(
      $(this).closest(".product__media-list-wrapper")
    );
  });
  $(document).on("init", ".product__media-sublist", function () {
    refreshProductMediaSlickPositionsAfterRender(
      $(this).closest(".product__media-list-wrapper")
    );
  });
  $(window).on("resize", syncProductMediaSublistHeightsDebounced);
  $(window).on("load", function () {
    bindProductMediaImageLoadRefresh(document);
    refreshProductMediaSlickPositionsAfterRender(document);
  });
});

// CART REFRESH EVENT
// -----------------------------------------------------------------------------

document.documentElement.addEventListener("cart:refresh", () => {
  const sectionsToUpdate = [
    { id: "cart-icon-bubble", selector: "#cart-icon-bubble" },
    { id: "CartDrawer", selector: "#CartDrawer" },
    { id: "main-cart-items", selector: "#main-cart-items .js-contents" },
    { id: "main-cart-footer", selector: "#main-cart-footer .js-contents" },
    { id: "cart-live-region-text", selector: "#cart-live-region-text" },
  ];

  sectionsToUpdate.forEach((section) => {
    fetch(`${routes.cart_url}?section_id=${section.id}`)
      .then((response) => response.text())
      .then((html) => {
        const parsed = new DOMParser().parseFromString(html, "text/html");
        const sourceEl = parsed.querySelector(section.selector);
        const destEl = document.querySelector(section.selector);
        if (sourceEl && destEl) {
          destEl.innerHTML = sourceEl.innerHTML;
        }
      })
      .catch((err) => console.error("cart:refresh error for", section.id, err));
  });
});

// CART REFRESH EVENT END
// -----------------------------------------------------------------------------
